export default "__VITE_ASSET__1278c14e__"